import { ComboField } from '@components/Fields/ComboField';
import { DocumentoField } from '@components/Fields/DocumentoField';
import { IntegerField } from '@components/Fields/IntegerField';
import { StringField } from '@components/Fields/StringField';
import { FixedFilterPanel } from '@components/FixedFilterPanel';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { IFilter } from '@hooks/useFilter';
import { Divider, MenuItem } from '@material-ui/core';
import { EnumContratoClienteStatus, IComboContratoClienteStatus } from '@model/ContratoClienteStatus';
import { EnumEmpresa, IComboEmpresa } from '@model/Empresa';
import { EnumOperadora, IComboOperadora } from '@model/Operadora';
import { IComboRemetenteWhatsapp } from '@model/RemetenteWhatsapp';
import { IContratoClienteFilter } from '@services/ContratoClienteService';
import React from 'react';

export type ContratoClienteFilterProps = {
    filter: IFilter<IContratoClienteFilter>
    isLoading: boolean
    contratoClienteStatusCombo: IComboContratoClienteStatus
    empresaCombo: IComboEmpresa
    operadoraCombo: IComboOperadora
    remetenteWhatsappCombo: IComboRemetenteWhatsapp
}

export function ContratoClienteFilter ({ filter, isLoading, contratoClienteStatusCombo, empresaCombo, operadoraCombo, remetenteWhatsappCombo }: ContratoClienteFilterProps) {
    const clienteNomeInputRef = React.createRef<HTMLInputElement>();
    
    const handleReset = React.useCallback(() => {
        filter.resetFilter();
    }, [filter]);

    return (
        <FixedFilterPanel
            onSearch={filter.handleFilterRequest}
            onClear={handleReset}
            disabled={isLoading}
        >
            <HorizontalGrid spacing={1}>
                <GridItem xs={1}>
                    <IntegerField
                        field={filter.fields.contratoClienteId}
                        label="ID Contrato"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={3}>
                    <StringField
                        inputRef={clienteNomeInputRef}
                        field={filter.fields.clienteNome}
                        label="Nome do Cliente"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={2}>
                    <DocumentoField
                        maskType="both"
                        field={filter.fields.clienteCpf}
                        onEnter={filter.handleFilterRequest}
                        dynamicLabels={{
                            cpf: "CPF do Cliente",
                            cnpj: "CNPJ do Cliente"
                        }}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={2}>
                    <IntegerField
                        field={filter.fields.linhaNumero}
                        label="Número"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.linhaContratoOperadoraEmpresaId}
                        label="Empresa"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value={EnumEmpresa.None}>Todas</MenuItem>
                        <Divider />
                        {
                            empresaCombo.createOptions()
                        }
                    </ComboField>
                </GridItem>

                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.linhaContratoOperadoraOperadoraId}
                        label="Operadora"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value={EnumOperadora.None}>Todas</MenuItem>
                        <Divider />
                        {
                            operadoraCombo.createOptions()
                        }
                    </ComboField>
                </GridItem>

                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.contratoClienteStatusId}
                        label="Status Contrato"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value={EnumContratoClienteStatus.None}>Todos</MenuItem>
                        <Divider />
                        {
                            contratoClienteStatusCombo.createOptions()
                        }
                    </ComboField>
                </GridItem>

                <GridItem xs={4}>
                    <StringField
                        field={filter.fields.usuarioLinha}
                        label="Usuário da Linha"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.whatsappEnvio}
                        label="Remetente"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value="">Todos</MenuItem>
                        {
                            remetenteWhatsappCombo.createOptionsWithNumero()
                        }
                    </ComboField>
                </GridItem>
            </HorizontalGrid>
        </FixedFilterPanel>
    )
}